import React from 'react';
import type { DodoReturnStatus } from '../../utils/dodoReturn';

interface PaymentFailureReturnModalProps {
  isOpen: boolean;
  status: Exclude<DodoReturnStatus, 'succeeded' | 'processing' | null>;
  onClose: () => void;
}

const MESSAGE_BY_STATUS: Record<'failed' | 'cancelled', string> = {
  failed:
    'Kart bilgileri hatalı olabilir, bakiyeniz yetersiz olabilir veya kartınız yurtdışı işlemlere kapalı olabilir. Lütfen kontrol edip tekrar deneyin.',
  cancelled:
    'Ödeme işlemi tamamlanmadı. Kart bilgileri, bakiye veya banka onayı nedeniyle işlem yarıda kalmış olabilir. Hazır olduğunuzda tekrar deneyebilirsiniz.',
};

export function PaymentFailureReturnModal({
  isOpen,
  status,
  onClose,
}: PaymentFailureReturnModalProps) {
  React.useEffect(() => {
    if (!isOpen) {
      return;
    }

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  React.useEffect(() => {
    if (!isOpen) {
      return;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[220] flex items-center justify-center px-4">
      <div
        className="absolute inset-0 bg-black/55 backdrop-blur-sm"
        aria-hidden="true"
        onClick={onClose}
      />

      <div className="relative w-full max-w-md overflow-hidden rounded-2xl border border-amber-200 bg-[#fffaf1] shadow-2xl">
        <div className="border-b border-amber-200 bg-gradient-to-r from-amber-100 to-orange-100 px-5 py-4">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-amber-800">
            Ödeme Durumu
          </p>
          <h2 className="mt-1 text-xl font-bold text-slate-900">
            Ödeme tamamlanamadı
          </h2>
        </div>

        <div className="px-5 py-5">
          <div className="flex items-start gap-3 rounded-xl border border-amber-200 bg-white/80 p-4">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-amber-100 text-xl">
              !
            </div>
            <div>
              <p className="text-sm leading-6 text-slate-700">
                {MESSAGE_BY_STATUS[status]}
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-amber-200 bg-white/70 px-5 py-4">
          <button
            onClick={onClose}
            className="w-full rounded-xl bg-slate-900 px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-slate-800"
          >
            Tamam
          </button>
        </div>
      </div>
    </div>
  );
}
